import { abreviaturas } from 'constantes';
import endPoints from 'endPoints/endPoints';
// eslint-disable-next-line import/no-cycle
import { IO } from '../io/IO';

// Se extrae la ruta
const { pdfViewer } = endPoints || {};

export class PdfViewerDao {
    static async validatePermission(solicitudId) {
        return IO.apiFetch(null, `${pdfViewer.validate}/${solicitudId}`, abreviaturas.DEFAULT_GET);
    }

    static async getDocumentReader(solicitudId) {
        return IO.apiFetch(null, `${pdfViewer.base}/${solicitudId}`, abreviaturas.DEFAULT_GET);
    }

    static async getDocumentReaderStatus(solicitudId) {
        return IO.apiFetch(null, `${pdfViewer.status}/${solicitudId}`, abreviaturas.DEFAULT_GET);
    }

    static async postDocumentReaderStatus(data, solicitudId) {
        return IO.apiFetch(data, `${pdfViewer.status}/${solicitudId}`, abreviaturas.DEFAULT_POST);
    }

    static async sendDocumentReader(dataFile, solicitudId) {
        return IO.apiFetch(dataFile, `${pdfViewer.base}/${solicitudId}`, abreviaturas.DEFAULT_POST);
    }
}
